/**
 * Information regarding the vehicle that belongs to the service order.
 * Before the order is booked (confirmServiceOrder), a full VIN (17 digits) must be provided
 * and the vehicle has to exist in the DMS.
 */
export type VehicleBrand =
  | 'BMW'
  | 'MINI'
  | 'MOT'
  | 'BMW_I'
  | 'RR'
  | 'ZINORO'
  | 'C_1'
  | 'TOYOTA'
  | 'HUSQVARNA'
  | 'UNKNOWN';

export class OrderVehicleInformation {
  /** Brand of the vehicle. May contain BMW brands (corporate brands) or others defined by the DMS. */
  brand?: VehicleBrand;

  /** Sales model name (German: "Modellbezeichnung"). */
  modelDesignation?: string;

  /** Registration number of the customer's vehicle. Can be used if VIN is not known at order creation. */
  numberPlate?: string;

  /** Vehicle identification number/chassis number (17 digits). */
  vin: string;
}
